type Props = {
  html: string;
  className?: any;
};
export default function HTMLPreview({ html, className }: Props) {
  return (
    <div className={className} dangerouslySetInnerHTML={{ __html: html }} />
  );
}
